import { IconButton } from "@mui/material";
import { useState } from "react";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ModalBase from "../popups/ModalBase";
import TransferUnassignedModal from "../popups/TransferUnassignedModal";

export default function TransferUnassignedButton({assignment, unassignedRecords, setUnassignedRecords, setAlertMessage}) {
    const [open, setOpen] = useState(false);
    return (
        <>
            <IconButton 
                size="small" 
                sx={{color: '#DC053C'}}
                onClick={(e) => {
                    e.stopPropagation();
                    setOpen(!open);
                }}
            >
                <SwapHorizIcon sx={{fontSize: "14px"}}/>
            </IconButton>
            {open && (
                <ModalBase 
                    minWidth={'720px !important'}
                    open={open}
                    handleClose={() => {
                        setOpen(false);
                    }}
                >
                    <TransferUnassignedModal assignment={assignment} handleClose={() => {setOpen(false)}} unassignedRecords={unassignedRecords} setUnassignedRecords={setUnassignedRecords} setAlertMessage={setAlertMessage}/>
                </ModalBase>
            )}
        </>
    )
}